import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { ChargingStationPrivateChargeRequest } from '@dto/ocpp/chargingStationPrivateChargeRequest';
import { ChargingStation } from '@models/charging-station';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { HttpState } from 'src/app/types/HttpState';


@Component({
  selector: 'app-enable-private-charge-dialog-content',
  templateUrl: './enable-private-charge-dialog-content.component.html',
  styleUrls: ['./enable-private-charge-dialog-content.component.css']
})
export class EnablePrivateChargeDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'EnablePrivateChargeDialogContentComponent';

  @Input() private chargingStation: ChargingStation;
  @Input() private currentStatus: boolean;

  public isResetPressed: boolean = false;
  public state: HttpState = '';

  constructor(
    public activeModal: NgbActiveModal,
    private chargingStationService: ChargingStationsService,
    injector: Injector) {
    super(activeModal, injector);
  }

  onConfirmClick() {
    this.isResetPressed = true;
    this.state = 'loading';

    var privateChargeRequest: ChargingStationPrivateChargeRequest = {
      PrivateCharging : true,
    }

    if (this.currentStatus == true) {
      privateChargeRequest.PrivateCharging = false;
    }

    this.chargingStationService.configurePrivateCharge(this.chargingStation.id, privateChargeRequest).subscribe(result => {
      if (result.status) {
        this.state = 'success';
      }
      else {
        this.state = 'failure';
      }
    }, error => {
        this.state = 'failure';
    });
  }

  onCancelClick() {
    this.activeModal.close({ state: 'failure' });
  }

  onOkClick() {
    this.activeModal.close({ state: this.state });
  }

}
